<template>
  <div class="pts">
    <div v-if="!modelValue" class="pts__search">
      <input v-model="query" class="pts__input" placeholder="Buscar por inquilino o código de nave..." @input="onInput" />
      <div v-if="results.length" class="pts__results">
        <button v-for="r in results" :key="r.plotId" class="pts__result" @click="select(r)">
          <span class="pts__result-tenant">{{ r.tenantName || 'Sin inquilino' }}</span>
          <span class="pts__result-plot">{{ r.plotName }}</span>
        </button>
      </div>
    </div>
    <div v-else class="pts__selected">
      <div>
        <div class="pts__selected-tenant">{{ modelValue.tenantName || 'Sin inquilino' }}</div>
        <div v-if="!modelValue.tenantName" class="pts__selected-contact">Los costos de este ticket serán gasto del parque.</div>
        <div class="pts__selected-plot">{{ modelValue.plotName }}</div>
        <div v-if="modelValue.operationalContact" class="pts__selected-contact">
          {{ modelValue.operationalContact.name }}{{ modelValue.operationalContact.phone ? ` · ${modelValue.operationalContact.phone}` : '' }}
        </div>
      </div>
      <button class="pts__clear" @click="$emit('update:modelValue', null)"><span class="mdi mdi-close"></span></button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { searchPlotsForTicket } from '@/services/maintenance'

const props = defineProps({ modelValue: { type: Object, default: null }, parkId: { type: String, required: true } })
const emit = defineEmits(['update:modelValue'])

const query = ref('')
const results = ref([])
let debounceHandle = null

function onInput() {
  if (debounceHandle) clearTimeout(debounceHandle)
  if (!query.value.trim()) { results.value = []; return }
  debounceHandle = setTimeout(async () => {
    results.value = await searchPlotsForTicket(props.parkId, query.value)
  }, 250)
}

function select(r) {
  results.value = []
  query.value = ''
  emit('update:modelValue', r)
}
</script>

<style scoped>
.pts__input { width: 100%; font-family: var(--font-body); font-size: 13px; background: #f8f9fc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 0.5rem 0.6rem; box-sizing: border-box; }
.pts__results { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 6px; margin-top: 0.4rem; overflow: hidden; }
.pts__result { display: flex; flex-direction: column; align-items: flex-start; width: 100%; padding: 0.5rem 0.6rem; background: none; border: none; cursor: pointer; text-align: left; }
.pts__result:hover { background: #f8fafc; }
.pts__result-tenant { font-family: var(--font-body); font-size: 13px; font-weight: 500; color: #1e3a5f; }
.pts__result-plot { font-family: var(--font-body); font-size: 11px; color: #64748b; }
.pts__selected { display: flex; align-items: center; justify-content: space-between; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 6px; padding: 0.5rem 0.6rem; }
.pts__selected-tenant { font-family: var(--font-body); font-size: 13px; font-weight: 500; color: #1e3a5f; }
.pts__selected-plot { font-family: var(--font-body); font-size: 11px; color: #64748b; }
.pts__selected-contact { font-family: var(--font-body); font-size: 10px; color: #94a3b8; }
.pts__clear { background: none; border: none; color: #94a3b8; cursor: pointer; display: flex; }
</style>